import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';
import type SearchConstituent from '@/types/api/SearchConstituent';
import ColumnMaxMinWidthClasses from '../constants/ColumnMaxMinWidthClasses';

const countryColumn = {
  columnKey: ConstituentSearchColumn.PRIMARY_COUNTRY,
  headerName: 'COUNTRY_LABEL',
  TableCellProps: {
    className: ColumnMaxMinWidthClasses,
  },
  render: (constituent: SearchConstituent) =>
    constituent.country ? constituent.country : null,
};

export default countryColumn;
